var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 28 40","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":""}},[_c('path',{attrs:{"d":"M6.88 0H0L22.24 20L0 40H6.88L28 20L6.88 0Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }